import { useState, useEffect } from "react";
import { pb } from "../services/pocketbase";
import { archiveService } from "../services/archiveService";

const PAGE_SIZE = 20;

export function useArchivedPagination() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  // Controle de Paginação (Simples com PB)
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  // --- BUSCA INICIAL / PAGINAÇÃO ---
  const fetchOrders = async (direction = "initial") => {
    setLoading(true);
    setIsSearching(false);

    try {
      let targetPage = pageNumber;
      if (direction === "next") targetPage++;
      if (direction === "prev" && targetPage > 1) targetPage--;
      if (direction === "initial") targetPage = 1;

      const result = await pb.collection("production_orders").getList(targetPage, PAGE_SIZE, {
        filter: "archived = true",
        sort: "-created",
      });

      // Mapeia full_data (Adapter)
      const mappedItems = result.items.map(r => ({
        id: r.id,
        ...r.full_data,
        ...r
      }));

      setOrders(mappedItems);
      setPageNumber(targetPage);
      setTotalPages(result.totalPages);

    } catch (error) {
      console.error("Erro paginação PB:", error);
    } finally {
      setLoading(false);
    }
  };

  // --- DISPARO DA BUSCA ---
  const triggerSearch = async (term) => {
    if (!term || term.trim().length === 0) {
      fetchOrders("initial");
      return;
    }

    setIsSearching(true);
    setLoading(true);
    try {
      const results = await archiveService.searchOrders(term);
      setOrders(results);
    } catch (error) {
      console.error("Erro na busca:", error);
      alert("Erro ao buscar.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders("initial");
  }, []);

  return {
    orders,
    loading,
    nextPage: () => fetchOrders("next"),
    prevPage: () => fetchOrders("prev"),
    pageNumber,
    hasMore: pageNumber < totalPages,
    triggerSearch,
    isSearching,
    refresh: () => fetchOrders("initial"),
  };
}
